/* ----------------------------------------------------------------------------
 * O rótulo e a direcção de um movimento de stock.
 *
 * Vinham de `movimento.saida` — um campo que não existe. O model tem
 * `tipoMovimento` ("entrada" | "saida" | "transferencia"); `saida` era sempre
 * `undefined`, logo sempre falso, logo TUDO aparecia como "Entrada". Na base de
 * testes eram 129 movimentos em 398 com o rótulo trocado — 111 saídas, 17
 * descartes e 1 transferência.
 *
 * O descarte não tem tipo próprio: grava-se como saída com o `descarteId`
 * preenchido, e é por aí que se distingue. Vale a pena distinguir, porque para
 * quem lê a lista não é a mesma coisa — uma saída foi consumida num
 * atendimento, um descarte foi deitado fora.
 *
 * A transferência sai da localização de origem, por isso leva a seta para cima,
 * mas com o nome dela: não é stock que a clínica tenha perdido.
 *
 * Vive num ficheiro à parte porque são três os sítios que mostram estas listas.
 * -------------------------------------------------------------------------- */
const classificarMovimento = (movimento) => {
  if (movimento.descarteId) return { rotulo: "Descarte", saida: true };
  if (movimento.tipoMovimento === "saida")
    return { rotulo: "Saída", saida: true };
  if (movimento.tipoMovimento === "transferencia")
    return { rotulo: "Transferência", saida: true };
  return { rotulo: "Entrada", saida: false };
};

export default classificarMovimento;
